
export default function Services() {
  const services = [
    {
      icon: 'ri-palette-line',
      title: 'Diseño Gráfico',
      description: 'Creamos identidad visual profesional: logotipos, manuales de marca, portadas y contenido para redes sociales',
      color: 'from-blue-500 to-cyan-500'
    },
    {
      icon: 'ri-instagram-line',
      title: 'Redes Sociales',
      description: 'Gestión profesional de tus redes sociales con contenido estratégico que genera engagement',
      color: 'from-purple-500 to-pink-500'
    },
    {
      icon: 'ri-megaphone-line',
      title: 'Meta Ads',
      description: 'Campañas publicitarias en Facebook e Instagram optimizadas para maximizar tu ROI',
      color: 'from-orange-500 to-red-500'
    },
    {
      icon: 'ri-robot-line',
      title: 'Automatización',
      description: 'Automatizamos procesos de marketing y ventas para escalar tu negocio eficientemente',
      color: 'from-green-500 to-emerald-500'
    },
    {
      icon: 'ri-line-chart-line',
      title: 'Analítica',
      description: 'Medimos y analizamos cada métrica para tomar decisiones basadas en datos reales',
      color: 'from-indigo-500 to-blue-500'
    },
    {
      icon: 'ri-customer-service-line',
      title: 'Consultoría',
      description: 'Asesoría estratégica personalizada para desarrollar tu plan de marketing digital',
      color: 'from-violet-500 to-purple-500'
    }
  ];

  return (
    <section id="services" className="py-24 px-8 md:px-6 relative">
      <div className="container mx-auto max-w-7xl">
        <div className="text-center mb-16 px-4 md:px-0">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">Nuestros Servicios</h2>
          <p className="text-lg md:text-xl text-gray-400 max-w-2xl mx-auto px-2">
            Soluciones completas de diseño y marketing digital para impulsar tu marca
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div 
              key={index}
              className="group bg-white/5 backdrop-blur-sm rounded-2xl p-8 border border-white/10 hover:border-white/20 transition-all duration-300 hover:transform hover:scale-105 hover:shadow-2xl cursor-pointer"
            >
              <div className={`w-16 h-16 rounded-xl bg-gradient-to-br ${service.color} flex items-center justify-center mb-6 group-hover:rotate-6 transition-transform duration-300`}>
                <i className={`${service.icon} text-3xl text-white`}></i>
              </div>
              <h3 className="text-2xl font-bold text-white mb-4">{service.title}</h3>
              <p className="text-gray-400 leading-relaxed">{service.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
